import React, { useRef, Dispatch, useMemo } from "react"
import { get, findIndex } from "lodash"

import { Panel } from "components/organisms/panel"
import { APIResponse } from "redux/apis/types"
import { PlotPositionsType } from "components/utils/chart"
import {
  ForeignSummaryAction,
  ForeignSummaryState,
  useDrawSummaryMap,
} from "components/actions/foreign"
import { BaseTable, InfoTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import MiddleChart from "components/molecules/chart/middleChart"
import { Tab } from "components/atoms/btn/tab"
import { foreignSummaryTableist } from "components/pages/main/foreign/summary"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { checkIsSp } from "utils/util"
import { DataDescription } from "../../organisms/panel/dataDescription"
import { ForeignEquityDisclaimerText } from "config/disclaimerText"

type PropsType = {
  state: ForeignSummaryState
  action: Dispatch<ForeignSummaryAction>
  foreignIndexData: APIResponse.Res
  canvasId: string
  symbolData: APIResponse.Res
  setSymbolData: Function
  setRefreshFlag: Function
}

export const SummaryTemplate: React.FC<PropsType> = props => {
  const mapArea = useRef()
  const resultList = get(props.foreignIndexData, "ResultList", [])
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])

  useDrawSummaryMap(
    mapArea.current,
    props.foreignIndexData,
    (data: PlotPositionsType, i?: number) => {
      props.action({ type: "CHANGE_TABLE_TYPE", displayType: 0 })
      const symbol = findIndex(resultList, {
        Symbol: data.index[i === undefined ? 0 : i],
      })
      props.action({ type: "CHANGE_SYMBOL", symbolIndex: symbol })
    },
    [mapArea.current]
  )

  return (
    <MainContainer className="foreign-summary">
      {!isPhone && (
        <Panel title="" className="world-map">
          <div ref={mapArea} />
        </Panel>
      )}
      <div className="symmetry-layout">
        <div className="contents-block">
          <Panel
            title=""
            className="panel-foreign-summary"
            // refresh={() => props.setRefreshFlag(true)}
            filter={
              <div className="panel-tab-container">
                <Tab
                  className="foot-border-tabs nav-tabs foreign-summary-tabs"
                  list={foreignSummaryTableist}
                  active={props.state.displayType}
                  onChange={(id: number) => {
                    props.action({
                      type: "CHANGE_TABLE_TYPE",
                      displayType: id,
                    })
                  }}
                />
              </div>
            }
          >
            <BaseTable
              className="table-list-view table-striped"
              list={foreignSummaryTableist[props.state.displayType].list}
              data={resultList}
              onClick={(data: APIResponse.Res, i: number) => {
                props.action({ type: "CHANGE_SYMBOL", symbolIndex: i })
                const _data = !isPhone ? data : { ...data }
                props.setSymbolData(_data)
              }}
              active={props.state.selectedSymbol}
            />
          </Panel>
        </div>
        {!isPhone && (
          <div className="contents-block index-detail-block">
            <Panel className="panel-main-index" title="" nonePanelHeader={true}>
              <MiddleChart id={props.canvasId} />
              {props.state.displayType === foreignSummaryTableist[0].id && (
                <InfoTable
                  list={infoTableColumns.common_list}
                  data={get(props.symbolData, "Symbol")}
                  className="table-striped table-index-detail"
                  wrapperCls="index-detail-table-row"
                />
              )}
            </Panel>
          </div>
        )}
      </div>
      {!isPhone && (
        <DataDescription
          className="panel-data-description"
          children={ForeignEquityDisclaimerText}
        />
      )}
    </MainContainer>
  )
}
